/**
 * Created by Bart Decorte
 * Date: 2019-07-12
 * Time: 09:43
 */

const LoadingStateImage = (LoadingStateImage = class {}) =>
  class extends LoadingStateImage {
    constructor(params) {
      super(params);

      this.$root = params.$root;

      this.loadImage().then(({ url, status }) => {
        this.setState(status);
        if (status === 'success' && url) {
          this.setState('');
          this.setPreviewImageUrl(url);
        }
      });
    }

    loadImage() {
      const $currentImage = this.$root.find('.js-preview-image');
      const url = $currentImage.data('url');

      if (!$currentImage.length || !url) {
        return new Promise((resolve) => {
          resolve({ status: '' });
        });
      }

      if ($currentImage.is('.loading')) {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => resolve({ url, status: 'success' });
          img.onerror = () => resolve({ url, status: 'error' });
          img.src = url;
        });
      }

      return new Promise((resolve) => {
        resolve({ status: 'success' });
      });
    }

    setState(state) {
      const $states = this.$root.find('.js-loader-states');
      $states
        .find('.js-state.d-flex')
        .removeClass('d-flex')
        .addClass('d-none');
      const $state = $states.find('.js-state--' + state);

      if ($state.length) {
        $state.removeClass('d-none').addClass('d-flex');
      }
    }

    setPreviewImageUrl(url) {
      const $currentImage = this.$root.find('.js-preview-image');
      if ($currentImage.is('img')) {
        $currentImage.attr('src', url);
      } else {
        $currentImage.css('background-image', "url('" + url + "')");
      }
    }
  };

export default LoadingStateImage;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/LoadingStateImage.js